import IconButton from '../IconButton';
import styled from 'styled-components';
import { convertColorWithoutOpacity } from 'utils/color';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${({ isMobile }) => (isMobile ? '12px' : '16px')};
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  background-color: ${({ theme }) => `${convertColorWithoutOpacity(theme.palette.primary.main, 0.1)}`} !important;
  position: relative;
  font-family: Lato;
  width: ${({ isMobile }) => (isMobile ? '100%' : 'fit-content')};
  min-width: ${({ minWidth }) => (minWidth ? `${minWidth}px` : 'unset')};
`;
export const ItemsContainer = styled.div `
  display: flex;
  gap: ${({ gap }) => (gap ? `${gap}px` : '16px')};
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : '0px')};
  flex-wrap: wrap;
`;
export const Item = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 6px;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  border-radius: 6px;
  background-color: white;
  width: fit-content;
`;
export const CloseButton = styled(IconButton) `
  position: absolute;
  right: 4px;
  top: 4px;
  color: ${({ theme }) => theme.palette.grey.A500};
`;
export const Link = styled.span `
  text-decoration: underline;
  cursor: pointer;
`;
